import { Component, OnInit, Inject, Input, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { Panel } from 'src/app/model/panel-modal/panel-model';
import { NotificationService } from 'src/app/shared/notification.service';
import { Candidate } from 'src/app/model/candidate.model';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { CandidateListModalComponent } from '../candidate-list-modal/candidate-list-modal.component';
import { PanelMemberListModalComponent } from '../panel-member-list-modal/panel-member-list-modal.component';

import { FormControl, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';


export interface DialogData {
  panelName: string;
  processId: number;
  panelButton: string;
  panelId: string;
  onEditPanelId: any;
  selectedPanelMember: any;
  selectedCandidate: any;

  // panelMembers: any;
  // candidates: any;
}
@Component({
  selector: 'app-create-panel',
  templateUrl: './create-panel.component.html',
  styleUrls: ['./create-panel.component.scss']
})
export class CreatePanelComponent implements OnInit {

  // @Input() panelButton: any;

  panelName: string;
  // panelButton: string;
  process="";
  cards= [];
  processId: number;
  panelId: string;
  panelButton: string;
  selectedPanelMember: any;
  selectedCandidate: any;
  onEditPanelId: any;
  autoPanelShowHide = false;
  selectedCandidates = 0;
  rejectedCandidates = 0;
  totalAssignedPerProcess = 0;
  numberOfPanel = [];
  allPanels: Panel[];
  panelNotYetStartedMap = new Map();
  panelInProcessMap = new Map();
  panelCompletedMap = new Map();
  onEditProcesslId = 0;
  processButton = "Create Process";
  panel: Panel[];

  // panelMembers: any;
  // candidates: any;

  selectedCandidatePerPanel: any;
  selectedPanelMemberPerPanel: any;
  fetchPanels = new EventEmitter();

  setPanelMembers = "";
  setCandidatesValues = "";

  constructor(public dialogRef: MatDialogRef<CreatePanelComponent>,
              public panelService: PanelService,
              private notificationService: NotificationService,
              public processService: ProcessService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
                this.processId = data.processId;
                this.panelId = data.panelId;
                this.panelButton = data.panelButton || "Create Room";
                this.onEditPanelId = data.onEditPanelId || 0;
                this.selectedCandidate = data.selectedCandidate;
                this.selectedPanelMember = data.selectedPanelMember;
               }

  ngOnInit() {
    this.panelService.panelMember$
    .subscribe(
      result => {
        this.setPanelMembers = result;
      }
    )

    this.panelService.selectedCandidates$
    .subscribe(
      result => {
        this.setCandidatesValues = result;
      }
    )
    this.selectedPanelMember = this.setPanelMembers;
    this.selectedCandidate = this.setCandidatesValues;
    if (this.panelService.form.value.meetingLink) {
      setTimeout(() => this.panelService.form.controls['meetingLink'].setValue(this.panelService.form.value.meetingLink), 0);
    }

    // console.log("Selected Panel Members on Create Room component",this.selectedPanelMember);
    // console.log("Selected Candidates on Create Room component", this.selectedCandidate);

  } 
  
  fetchMeetingLink(meetingLinkProvider: String) {
    this.panelService.fetchMeetingLink(meetingLinkProvider)
      .then(response => {
        const { data } = response;
        const { meetingLink } = data;
        this.panelService.form.controls['meetingLink'].setValue(meetingLink);
        this.notificationService.success("Successfully added")
      }).catch(err => {
        const { errors } = err;
        errors.forEach(error => {
          const { message } = error;
          this.notificationService.warn(message);
        });
      })
  }

  clearMeetingLink() {
    this.panelService.form.controls['meetingLink'].setValue(null);
    this.clearNotification();
  }


  // onSubmitPanelCreation(processId) {                         //processId

  //   // if (this.panelService.form.valid) {
  //     if (this.panelButton === "Update Room") {
  //       let panelName = this.panelService.form.value.panelName;
  //       let roomIdentification = this.panelService.form.value.roomIdentification;
  //       // let panelMembers = this.selectedPanelMember;
  //       // let candidates = this.selectedCandidate;
  //       let panel = new Panel(panelName, roomIdentification);       //, panelMembers, candidates
  //       this.panelService.updatePanel(panel, this.onEditPanelId).then(
  //         updatePanels => {
  //           this.tabClick(updatePanels.processId);
  //         },
  //         err => {
  //           console.log(err);
  //           this.notificationService.warn("::Unable to update the panel, " + err);
  //           return false;
  //         }
  //       );
  //       this.notificationService.success('Panel Successfully updated');
  //     }
     
     
  //     else {
  //       let panelName = this.panelService.form.value.panelName;
  //       let roomIdentification = this.panelService.form.value.roomIdentification;
  //       // ----let panelMembers = this.selectedPanelMember;----
  //       // -----let candidates = this.selectedCandidate;------
  //       let panel = new Panel(panelName, roomIdentification);                   //, panelMembers, candidates
  //       this.panelService.createPanel(panel, this.processId).then(              //processId
  //         createPanel => {
  //           this.tabClick(this.processId);                                      //processId
  //         },
  //         err => {
  //           console.log(err);
  //           this.notificationService.warn("::Unable to create the panel, " + err);
  //           return false;
  //         }
  //       );
  //       this.notificationService.success('Panel Successfully created');
  //       console.log("Inside Create Button clicked");

  //      }
  //      console.log("clicked");

  //     this.onClose();
  //   // }

  // }



  onSubmitPanelCreation(processId) {
    if (this.panelService.form.valid) {
      if (this.panelButton === "Update Room") {
        
        let panelName = this.panelService.form.value.panelName;
        let roomIdentification = this.panelService.form.value.roomIdentification;
        const meetingLink = this.panelService.form.value.meetingLink || null;
        let panelMembers = this.selectedPanelMember;
        let candidates = this.selectedCandidate;
        let panel = new Panel(panelName, roomIdentification, panelMembers, candidates, meetingLink);
        if (panelMembers.length === 0 ||
              candidates.length === 0 ||
              panelName === '' ||
              panelName === null ||
              roomIdentification === '' ||
              roomIdentification === null) {
          this.notificationService.warn("Please fill all the fields");
          this.tabClick(false);
        }
        else {
          this.panelService.updatePanel(panel, this.onEditPanelId).then(
            updatePanels => {
              this.fetchPanels.emit(updatePanels.processId);
              // this.tabClick(updatePanels.processId);
              this.allPanels = updatePanels;
              window.location.reload();
            },
            err => {
              console.log(err);
              if (typeof err === 'object' && err.errorMessage) {
                const { errorMessage } = err;
                this.notificationService.warn("Unable to update the panel, " + errorMessage);
              } else {
                this.notificationService.warn("Unable to update the panel, " + err);
              }
              this.fetchPanels.emit(false);
              return false;
            }
          );
          this.notificationService.success('Panel Successfully updated');
          // window.location.reload()
          // console.log("---------This is for the UPDATE PANEL button-------------")
          // console.log("-----Inside onEditPanel() Panel Members-------", this.selectedPanelMember);
          // console.log("-----Inside onEditPanel() Candidates-------", this.selectedCandidate);
        }
      } else {
        let panelName = this.panelService.form.value.panelName;
        let roomIdentification = this.panelService.form.value.roomIdentification;
        const meetingLink = this.panelService.form.value.meetingLink || null;
        let panelMembers = this.selectedPanelMember;
        let candidates = this.selectedCandidate;
        let panel = new Panel(panelName, roomIdentification, panelMembers, candidates, meetingLink);
        this.panelService.createPanel(panel, processId).then(
          createPanel => {
            this.fetchPanels.emit(createPanel);
            window.location.reload();
            // this.tabClick(processId);
          },
          err => {
            console.log(err);
            this.fetchPanels.emit(false);
            this.notificationService.warn("Unable to create the panel, " + err);
            return false;
          }
        );
        this.notificationService.success('Panel Successfully created');
      }
      // this.onClose();
    }
    this.onClose();
    
  }
  

  tabClick(processId) {
    this.autoPanelShowHide = true;
    this.selectedCandidates = 0;
    this.rejectedCandidates = 0;
    this.totalAssignedPerProcess = 0;
    this.numberOfPanel = [];
    this.panelService.findAll(processId).then(
      allPanels => {
        this.allPanels = allPanels;
        if (allPanels != null) {
          for (let i = 0; i < allPanels.length; i++) {
            this.autoPanelShowHide = false;
            this.numberOfPanel.push(allPanels[i].panelId);
            this.totalSelectedRejected(allPanels[i].panelCandidates);
            this.totalAssignedPerProcess = this.totalAssignedPerProcess + allPanels[i].assignedCnt;
            if (allPanels[i].assignedCnt === allPanels[i].selectedCnt + allPanels[i].rejectedCnt) {
              this.panelCompletedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt === 0 && allPanels[i].rejectedCnt === 0) {
              this.panelNotYetStartedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt > 0 || allPanels[i].rejectedCnt > 0) {
              this.panelInProcessMap.set(allPanels[i].panelId, true);
            }
          }
        }
      },
      err => {
        console.log(err);
      }
    );
    this.processFormReset();
    this.panelFormReset();
  }

  processFormReset() {
    this.onEditProcesslId = 0;
    this.processButton = "Create Process";
    this.processService.form.reset();
    this.processService.form.controls.processName.setErrors(null);
    this.processService.form.controls.startDate.setErrors(null);
    this.processService.form.controls.endDate.setErrors(null);
  }

  panelFormReset() {
    this.onEditPanelId = 0;
    this.panelButton = "Create Room";
    this.panelService.form.reset();
    this.panelService.form.controls.panelName.setErrors(null);
    this.panelService.form.controls.roomIdentification.setErrors(null);
    // this.panelService.form.controls.panelMembers.setErrors(null);
    // this.panelService.form.controls.candidates.setErrors(null);
  }

  totalSelectedRejected(allPanelCandidate: Candidate[]) {
    for (let i = 0; i < allPanelCandidate.length; i++) {
      if (allPanelCandidate[i].status == 2) {
        this.selectedCandidates = this.selectedCandidates + 1;
      } else if (allPanelCandidate[i].status == 3) {
        this.rejectedCandidates = this.rejectedCandidates + 1;
      }
    }
  }

  clearPanelForm() {
    this.onEditPanelId = 0;
    this.panelButton = "Create Room";
    this.panelService.form.reset();
    this.clearNotification();
  }
  
  clearNotification() {
    this.notificationService.success('Cleared');
  }


  panelMemberListModal(processId, panelId) {
    this.selectedPanelMember = [];
    const dialogRef = this.dialog.open(PanelMemberListModalComponent, {
      width: '60%',
      disableClose: true,
      autoFocus: true,
      data: { selectedPanelMemberPerPanel: this.selectedPanelMemberPerPanel, processId: processId, onEditPanel: this.onEditPanelId }    //onEditPanel: this.onEditPanelId 
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      let allPanelMember = "";
      if (typeof result !== "undefined") {
        this.selectedPanelMemberPerPanel = result; 
        for (let row of result.selectedPanelMemberPerPanel[0]) {
          allPanelMember = allPanelMember + row.panelMemberName + ", ";
          this.selectedPanelMember.push(row.panelMemberId);
        }
        allPanelMember = allPanelMember.substring(0, allPanelMember.length-2);
        this.panelService.form.controls['panelMembers'].setValue(allPanelMember);
      }
    });
  }


  candidateListModal(processId, panelId) {
    const dialogRef = this.dialog.open(CandidateListModalComponent, {
      width: '80%',
      disableClose: true,
      autoFocus: true,
      data: { selectedCandidatePerPanel: this.selectedCandidatePerPanel, processId: processId, onEditPanel: this.onEditPanelId}     //onEditPanel: this.onEditPanelId
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedCandidate = [];
      console.log('The dialog was closed');
      let allCandidate = "";
      if (typeof result !== "undefined") {
        this.selectedCandidatePerPanel = result;
        for (let row of result.selectedCandidatePerPanel[0]) {
          allCandidate = allCandidate + row.candidateName + ", ";
          this.selectedCandidate.push(row.candidateId);
        }
        allCandidate = allCandidate.substring(0, allCandidate.length-2)
        this.panelService.form.controls['candidates'].setValue(allCandidate);
      }
    });
  }


  onClose() {
    this.dialogRef.close();
    this.panelFormReset();
  }

}
